import $http from '../../axios';
import {Notification} from 'element-ui';
import {getApiDomain, getDomain} from "../../util/domains";

export async function downloadTemplate({}) {
    var data = ['Sede',
        'TipC',
        'Prefijo',
        'Num-Com',
        'Fec-Com',
        'Cod-tercero',
        'Nombre',
        'Forma-pag',
        'Descrip Forma-pag',
        'Valor',
        'Fec-Ven',
        'No.Che-Vauc',
        'Autotizac',
        'Cod-Estado',
        'Estado-Cheq',
        'Cons-PVE',
        'Cons-TIP',
        'Cons-NUM'
    ];

    var csv = "";
    data.map((v, i) => {
        csv += `${v};`;
    });
    csv =   csv.substring(0, csv.length - 1)
    var hiddenElement = document.createElement("a");
    hiddenElement.href = "data:text/csv;charset=utf-8," + encodeURI(csv);
    hiddenElement.target = "_blank";
    hiddenElement.download = "formas-pago-template.csv";
    hiddenElement.click();
}
export async function fetchValidates_file({state,commit}) {
    let formData = new FormData();
    commit('setPreloader', true);
    formData.append('validated', state.params.validated);
    formData.append('file', state.params.file);

    $http.post(`/api/incorporar-formas-pago-documents`, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        }
    ).then((response) => {
        console.log(response.data,'response')
        commit('setValidationdata', response.data);
        commit('setPreloader', false);
        if (!response.data.success){
            window.open(getApiDomain() + response.data.url_report_error, '_blank');
            Notification.error({
                title: "Error!",
                message: 'El excel tiene informacion inocrrecta, por favor valida el excel con los errores encontrados',
                type: "error",
                duration: 10000,
                customClass: "notification-box"
            });
        }else{
            if (response.data.finish){
                commit('reset_state');
                Notification.success({
                    title: "Success!",
                    message: response.data.message,
                    type: "success",
                    duration: 4000,
                    customClass: "notification-box"
                });

            }else{
                Notification.success({
                    title: "Success!",
                    message: 'Validación Finalizada exitosamente',
                    type: "success",
                    duration: 4000,
                    customClass: "notification-box"
                });
            }

        }
    }).catch(error => {
        commit('setPreloader', false);
        Notification.error({
            title: "Error!",
            message: error.message,
            type: "error",
            duration: 3000,
            customClass: "notification-box"
        });
    });
}




// WEBPACK FOOTER //
// ./src/modules/import-payment-methods-document/actions.js